import React, { Component } from 'react'
import {
  Container,
  Row,
  Col,
  Table,
  Spinner,
  Button,
  Modal,
  Form,
  FormControl,
} from 'react-bootstrap'
import { AiOutlineRedo, AiOutlineEdit, AiOutlineSave, AiOutlineClose } from 'react-icons/ai'
import ReactPaginate from 'react-paginate';

const defaultOptions = [
  'trader',
  'totalorders',
  'totalpendingorders',
  'currentamount',
  'maxdailyqty',
  'currentcumopenvalue',
  'maxdailyamount',
  'maxmargin',
  'totaltrades',
  'currentmargin'
]

class CurrentRisk extends Component {
  constructor(props) {
    super(props)

    this.state = {
      current_risk: this.props.current_risk,
      displayOptions: this.props.displayOptions || defaultOptions,
      maxAmountOfOptions: 10,
      entryToEdit: {
        item: '',
        option: '',
        value: ''
      },
      traderQuery: '',
      currentPage: 0,
      limit: 20,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        displayOptions: nextProps.displayOptions,
        current_risk: nextProps.current_risk,
      })
    }
  }

  parseKeysIntoArray = object => {
    let array = []
    if (object) {
      if (Object.keys(object).length > 0) {
        array = Object.keys(object)
      }
    }

    return array
  }


  handleCloseConfigureDisplayModal = () => {
    this.setState({
      showConfigureDisplayModal: false
    })
  }

  handleShowConfigureDisplayModal = () => {
    this.setState({
      showConfigureDisplayModal: true
    })
  }

  handleModifyDisplayOptions = key => {
    const newOptions = JSON.parse(JSON.stringify(this.state.displayOptions))

    if (newOptions.includes(key)) {
      const index = newOptions.indexOf(key)
      newOptions.splice(index, 1)
    } else {
      if (newOptions.length < this.state.maxAmountOfOptions) {
        newOptions.push(key)
      }
    }

    this.props.setDisplayOptionsCurrentRisk(newOptions)
  }

  handleResetDisplayOptions = () => {
    this.setState({
      displayOptions: ['firm', 'trader'],
    })
  }

  handleSelectEntryToEdit = (option, item, value) => {
    this.setState({
      entryToEdit: {
        option: option,
        item: item,
        value: value,
      }
    })
  }

  handleStopEditingEntry = () => {
    this.setState({
      entryToEdit: {
        option: '',
        item: '',
        value: ''
      }
    })
  }

  handleEditEntry = (e, item, option) => {
    this.setState({
      entryToEdit: {
        ...this.state.entryToEdit,
        value: e.target.value
      }
    })
  }

  handleSaveEditedEntry = () => {
    const { option, value, item } = this.state.entryToEdit
    const new_current_risk = this.state.current_risk

    const message = {
      type: 'account_update',
      firm: item.firm,
      trader: item.trader,
    }

    message[option] = value

    this.props.websocket.send(JSON.stringify(message))
    this.handleStopEditingEntry()
  }

  handleFilterData = () => {
    const { current_risk, traderQuery } = this.state
    let content
    if (current_risk) {
      if (traderQuery) {
        const userIds = Object.keys(current_risk)
        let obj = {}
        const filter = userIds.filter(function(userId) {
          function isValid(str) { // tests validity of the string, which may throw an error in regex
           return !/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str)
          }
          const query = isValid(traderQuery) ? traderQuery : `\\` + traderQuery
          const regexp = new RegExp(query, 'i')
          if (userId.match(regexp)) {
            obj[userId] = current_risk[userId]
          }
        })
        content = obj
      } else {
        content = current_risk
      }
    }

    return content
  }

  handleChangeQuery = e => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleClickPage = number => {
    const scrollHere = document.getElementById('scroll-here')
    const topPos = scrollHere.offsetTop
    const test = document.getElementsByClassName('admin-content-pane')
    test[0].scrollTop = topPos
    this.setState({
      currentPage: number.selected
    })
  }

  /****************************************************************************/

  renderLoading = () => {
    const span = this.state.displayOptions.length
    return (
      <tr>
        <td colSpan={span}>
          <Row noGutters className='app-spinner full-height'>
            <Spinner animation='border' className='common-grey-spinner' />
          </Row>
        </td>
      </tr>
    )
  }

  renderTable = props => {
    const { displayOptions } = this.state
    const current_risk = this.handleFilterData()
    const arrayOfKeys = this.parseKeysIntoArray(current_risk)

    let body
    if (arrayOfKeys.length > 0) {
      const { currentPage, limit } = this.state
      const a = currentPage == 0 ? 0 : (((currentPage + 1) * limit) - limit)
      const b = ((currentPage + 1) * limit)
      let arrayOfValues = Object.values(current_risk)
      arrayOfValues = arrayOfValues.slice(a, b)
      body = arrayOfValues.map((item, index) => this.renderTableItem(item, index))
    } else {
      const span = this.state.displayOptions.length
      body = (
        <tr>
          <td colSpan={span} className='centered-td'>
            Nothing found
          </td>
        </tr>
      )
    }

    let tableHeaders
    if (displayOptions.length > 0) {
      tableHeaders = displayOptions.map((option, index) => this.renderTableHeader(option, index))
    }

    return (
      <div className='submissions-table-container'>
        <Table responsive bordered className='submissions-table'>
          <thead>
            <tr>
              {tableHeaders}
            </tr>
          </thead>

          <tbody>
            {body}
          </tbody>
        </Table>
      </div>
    )
  }

  renderTableHeader = (option, index) => (
    <th key={'tableHeader - index: ' + index} className='table-header-cell'>{option}</th>
  )

  renderTableItem = (item, index) => {
    const { displayOptions } = this.state

    let tableContents
    if (displayOptions.length > 0) {
      tableContents = displayOptions.map((option, index) => this.renderMatchingTableItem(item, option, index))
    }
    return (
      <tr key={'tableItem - index: ' + index} className='table-cell'>
        {tableContents}
      </tr>
    )
  }

  renderMatchingTableItem = (item, option, index) => {
    const { entryToEdit } = this.state

    let content
    if (option == 'trader' || option == 'firm') {
      content = item[option]
    } else {
      if (entryToEdit.item.trader === item.trader && entryToEdit.option === option) {
        content = (
          <Row noGutters className='table-cell-row'>
            <FormControl
              onChange={e => this.handleEditEntry(e, item, option)}
              value={entryToEdit.value}
              className='table-cell-formControl'/>
          </Row>
        )
      } else {
        content = (
          <Row noGutters className='table-cell-row'>
            {item[option]}
          </Row>
        )
      }
    }

    return (
      <td
        key={'matchingTableItem - index: ' + index}
        className='matching-table-item'>
        {content}
      </td>
    )
  }

  renderConfigureDisplayModal = () => {
    const { showConfigureDisplayModal, current_risk, maxAmountOfOptions } = this.state
    const arrayOfKeys = this.parseKeysIntoArray(current_risk)

    let content
    if (arrayOfKeys.length > 0) {
      const values = current_risk[arrayOfKeys[0]]
      const arrayOfKeysFromValues = Object.keys(values)
      content = arrayOfKeysFromValues.map(key => this.renderKeyCheckbox(key))
    }

    return (
      <Modal
        centered
        className='common-modal'
        show={showConfigureDisplayModal}
        onHide={this.handleCloseConfigureDisplayModal}>

        <Modal.Header className='common-modal-header' closeButton>
          Risk Settings Display Options
        </Modal.Header>

        <Modal.Body>
          <div className='max-amount-of-options'>
            You can select up to {maxAmountOfOptions} options
          </div>
          <Form>
            <Row noGutters className='risk-settings-content-row'>
              {content}
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <AiOutlineRedo
            onClick={this.handleResetDisplayOptions}
            className='individual-form-icon' />
          <Button
            onClick={this.handleCloseConfigureDisplayModal}
            className='teal-button' size='sm'>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  renderKeyCheckbox = key => {
    const { displayOptions } = this.state
    return (
      <Form.Check
        checked={displayOptions.includes(key) ? true : false}
        onChange={() => this.handleModifyDisplayOptions(key)}
        className='risk-settings-key-checkbox'
        key={key} name={key} size='sm' label={key} />
    )
  }

  renderConfigureDisplayButton = () => {
    return (
      <Button
        onClick={this.handleShowConfigureDisplayModal}
        className='teal-button' size='sm'>
        Configure Display
      </Button>
    )
  }

  renderSearchBar = () => {
    const { traderQuery } = this.state
    const disabled = !traderQuery ? true : false

    return (
      <Row noGutters className='search-bar-row'>
        <div className='search-bar'>
          <label className='search-label'>Look up a trader:</label>
          <FormControl
            value={traderQuery}
            name='traderQuery'
            placeholder='Look up a trader...'
            className='search-form-control'
            onChange={this.handleChangeQuery} />
        </div>
      </Row>
    )
  }

  renderPagination = () => {
    const keys = Object.keys(this.state.current_risk)
    if (keys.length > 0) {
      const total = keys.length
      const { currentPage, limit } = this.state
      const numberOfPages = Math.ceil(total / limit)

      return (
        <Row noGutters className='pagination-row'>
          <ReactPaginate
            previousLabel={'<'}
            previousClassName={'pagination__item pagination__arrow'}
            previousLinkClassName={'pagination__icon pagination__icon--prev'}
            nextLabel={'>'}
            nextClassName={'pagination__item pagination__arrow'}
            nextLinkClassName={'pagination__icon pagination__icon--next'}
            breakLabel={'...'}
            breakClassName={'pagination__ellipsis'}
            breakLinkClassName={'pagination__ellipsis-link'}
            pageCount={numberOfPages}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={this.handleClickPage}
            containerClassName={'pagination__list'}
            activeLinkClassName={'pagination__link--active'}
            pageClassName={'pagination__item'}
            pageLinkClassName={'pagination__link'}
            forcePage={currentPage}
          />
        </Row>
      )
    }
  }

  render() {
    return (
      <Container fluid className='admin-content-container' id='scroll-here'>
        {this.renderConfigureDisplayModal()}

        <Row noGutters className='forms-header'>
          <h4>Risk Monitor</h4>
          {this.renderConfigureDisplayButton()}
        </Row>

        <div className='forms-table-box'>
          {this.renderSearchBar()}
          {this.renderTable(this.props)}
          {this.renderPagination()}
        </div>

      </Container>
    )
  }
}

export default CurrentRisk
